<template>
  <div id="footer-wrapper">
    <footer>
      <el-row
        type="flex"
        align="middle"
        justify="space-between"
        id="footer-nav-row"
      >
        <el-col :span="10" id="nav-col-left">
          <div class="nav-wrapper">
            Brought to you by
            <a href="https://www.revolutiones.com/" target="_blank">
            <img src="../assets/revolution_logo_default.png" height="40px" />
           </a>
            <!-- <strong
              >Solutions by and for the entertainment industry, supporting your
              production at every step.</strong
            > -->
          </div>
        </el-col>
        <el-col :span="14" id="nav-col-right">
          <div class="nav-wrapper footer-item">PAYROLL</div>
          <div class="nav-wrapper footer-item">TAX INCENTIVES</div>
          <div class="nav-wrapper footer-item">LABOR RELATIONS</div>
          <div class="nav-wrapper footer-item">DIGITAL CREW ONBOARDING</div>
          <div class="nav-wrapper footer-item">SHORT-FORM BUDGETING</div>
          <div class="nav-wrapper footer-item">PRODUCTION PLANNING</div>
          <div class="nav-wrapper footer-item">ACCOUNTING</div>
          <div class="nav-wrapper footer-item">WATERMARKING & DISTRIBUTION</div>
        </el-col>
      </el-row>
    </footer>
  </div>
</template>

<script>
import ElCol from 'element-ui/packages/col/src/col'

export default {
  components: {
    ElCol
  },
  name: 'footer'
}
</script>

<style scoped>
#footer-wrapper {
  background-color: #fff;
  padding: 0;
  color: #000;
  position: relative;
}
#footer-nav-row {
  padding: 0 12px;
  height: 60px;
}
#nav-col-left {
  text-align: left;
}
#nav-col-left .nav-wrapper:first-child {
  padding: 0 6px;
}
#nav-col-left .nav-wrapper:nth-child(2) :nth-child(2) {
  font-weight: 500;
}
#nav-col-right {
  text-align: right;
}
.nav-wrapper {
  display: inline-block;
  vertical-align: middle;
}
.nav-wrapper img {
  margin: 0 10px;
}
.footer-item {
  padding: 0 6px;
  font-weight: 500;
  line-height: 10px;
  border-left: 1px solid #ccc;
}
.footer-item:first-child {
  border-left: none;
}
footer {
  vertical-align: middle;
  color: #000;
  top: 0;
  border-top: 1px solid #e3e3e3;
  font-size: 10px;
  left: 0;
  width: 100%;
  z-index: 9;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/layouts/Footer.vue